module.exports = __webpack_public_path__ + "img/conveyor-belt-boxes.d9da431e.svg";